import {
  ACCESSION_ID,
  ClindxTableFilterType,
  Constants,
  DATA_CREATION_DATE,
  DOB_FORMAT,
  EMAIL_COLUMN_CLASS,
  FIRST_NAME,
  HEAD_CREATION_DATE,
  HEAD_EXSHORT,
  HEAD_EXSHORT_PADDING_RIGHT,
  HEAD_EXSHORT_PADDING_RIGHT_REPORT,
  HEAD_MEDIUM,
  HEAD_SELECT,
  HEAD_SHORT,
  ANNOUNCEMENT_LAST_UPDATED_ON,
  ANNOUNCEMENT_LAST_UPDATED_BY,
  OVERFLOW_CONTROL,
  OVERFLOW_CONTROL_CONTENTWRAP_RESULT_GRID,
  OVERFLOW_CONTROL_CONTENT_WRAP,
  OVERFLOW_CONTROL_CONTENT_WRAP_MANAGE_PACKAGE_GRID,
  PADDING_RIGHT,
  REQUISITION_NUMBER_LABEL,
  TEXT_CENTER,
  TEXT_CENTER_OVERFLOW_CONTROL
} from './clindx-mat-table.shared';

export const OrderTrackerColumnList = [
  {
    columnName: 'results',
    columnDisplayValue: ' ',
    classThName: HEAD_EXSHORT,
    classTdName: OVERFLOW_CONTROL_CONTENT_WRAP,
    columnWidth: '4%',
    hasSort: false
  },
  {
    columnName: 'requisitionNumber',
    columnDisplayValue: REQUISITION_NUMBER_LABEL,
    classThName: HEAD_EXSHORT,
    classTdName: OVERFLOW_CONTROL_CONTENT_WRAP,
    columnWidth: '15%'
  },
  {
    columnName: 'primaryId',
    columnDisplayValue: 'ID1',
    classThName: HEAD_EXSHORT,
    classTdName: OVERFLOW_CONTROL_CONTENT_WRAP,
    columnWidth: '15%',
    hasSort: false
  },
  {
    columnName: 'secondaryId',
    columnDisplayValue: 'ID2',
    classThName: HEAD_EXSHORT,
    classTdName: OVERFLOW_CONTROL_CONTENT_WRAP,
    columnWidth: '15%',
    hasSort: false
  },
  {
    columnName: 'accountCode',
    columnDisplayValue: 'Account',
    classThName: HEAD_EXSHORT,
    classTdName: OVERFLOW_CONTROL_CONTENT_WRAP,
    columnWidth: '20%',
    hasSort: false
  },
  {
    columnName: 'receivingLabCode',
    columnDisplayValue: 'Receiving Lab',
    classThName: HEAD_EXSHORT,
    classTdName: OVERFLOW_CONTROL_CONTENT_WRAP,
    columnWidth: '13%',
    hasSort: false
  },
  {
    columnName: 'percentage',
    columnDisplayValue: 'Status',
    classThName: HEAD_EXSHORT,
    classTdName: OVERFLOW_CONTROL_CONTENT_WRAP,
    columnWidth: '13%'
  },
  {
    columnName: 'report',
    columnDisplayValue: 'Report',
    classThName: HEAD_SELECT,
    classTdName: '',
    columnWidth: '2%',
    hasSort: false
  }
];

export const OrderTrackerTestColumnList = [
  {
    columnName: 'test',
    columnDisplayValue: 'Test(s)',
    classThName: HEAD_EXSHORT,
    classTdName: OVERFLOW_CONTROL,
  },
  {
    columnName: 'status',
    columnDisplayValue: 'Status',
    classThName: HEAD_EXSHORT,
    classTdName: OVERFLOW_CONTROL,
  }
];

export const PackageColumnList = [
  {
    columnName: 'orderDetails',
    columnDisplayValue: ' ',
    classThName: HEAD_SHORT,
    classTdName: OVERFLOW_CONTROL,
    columnWidth: '2%',
    hasSort: false
  },
  {
    columnName : 'labPortPackageCode',
    columnDisplayValue : 'Package ID',
    classThName: 'head-long',
    classTdName: OVERFLOW_CONTROL_CONTENT_WRAP_MANAGE_PACKAGE_GRID,
    columnWidth: '16%'
  },
  {
    columnName : 'createdOn',
    columnDisplayValue : 'Created On',
    classThName: 'head-long',
    classTdName: OVERFLOW_CONTROL_CONTENT_WRAP_MANAGE_PACKAGE_GRID,
  },
  {
    columnName : 'shippedOn',
    columnDisplayValue : 'Shipped On',
    classThName: 'head-long',
    classTdName: OVERFLOW_CONTROL_CONTENT_WRAP_MANAGE_PACKAGE_GRID,
  },
  {
    columnName : 'accounts',
    columnDisplayValue : 'Account(s)',
    classThName: 'head-long',
    classTdName: OVERFLOW_CONTROL_CONTENT_WRAP_MANAGE_PACKAGE_GRID,

  },
  {
    columnName : 'receivingLab',
    columnDisplayValue : 'Receiving Lab',
    classThName: HEAD_MEDIUM,
    classTdName: OVERFLOW_CONTROL_CONTENT_WRAP_MANAGE_PACKAGE_GRID,
  },
  {
    columnName : 'requestTypes',
    columnDisplayValue : 'Request Type',
    classThName: HEAD_MEDIUM,
    classTdName: OVERFLOW_CONTROL_CONTENT_WRAP_MANAGE_PACKAGE_GRID,
    hasSort: false
  },
  {
    columnName : 'shipperType',
    columnDisplayValue : 'Shipper Type',
    classThName: HEAD_MEDIUM,
    classTdName: OVERFLOW_CONTROL_CONTENT_WRAP_MANAGE_PACKAGE_GRID,
  },
  {
    columnName : 'status',
    columnDisplayValue : 'Status',
    classThName: HEAD_SHORT,
    classTdName: '',
  },
  {
    columnName : 'trackingNumber',
    columnDisplayValue : 'Tracking ID',
    classThName: HEAD_MEDIUM,
    classTdName: OVERFLOW_CONTROL_CONTENT_WRAP,
  },
  {
    columnName: 'actions',
    columnDisplayValue: 'Actions',
    classThName: 'head-short-actions',
    classTdName: HEAD_SHORT,
    hasSort: false
  }
];

export const PackageOrderColumnList = [
  {
    columnName: 'requisitionId',
    columnDisplayValue: REQUISITION_NUMBER_LABEL,
    classTdName: TEXT_CENTER,
    classThName: TEXT_CENTER,
    columnWidth: '20%'
  },
  {
    columnName: 'specimens',
    columnDisplayValue: '# of Specimens',
    classTdName: TEXT_CENTER,
    classThName: TEXT_CENTER,
    columnWidth: '10%'
  },
  {
    columnName: 'tests',
    columnDisplayValue: 'Test(s)/Panel(s)',
    classTdName: TEXT_CENTER_OVERFLOW_CONTROL,
    classThName: TEXT_CENTER,
    columnWidth: '24%'
  },
  {
    columnName: 'primaryId',
    columnDisplayValue: 'Primary ID',
    classTdName: TEXT_CENTER_OVERFLOW_CONTROL,
    classThName: TEXT_CENTER,
    columnWidth: '14%'
  },
  {
    columnName: 'secondaryId',
    columnDisplayValue: 'Secondary ID',
    classTdName: TEXT_CENTER_OVERFLOW_CONTROL,
    classThName: TEXT_CENTER,
    columnWidth: '14%'
  },
  {
    columnName: 'actions',
    columnDisplayValue: 'Actions',
    classTdName: TEXT_CENTER,
    classThName: TEXT_CENTER,
    columnWidth: '16%'
  }
];

export const OrderResultColumnList = [
  {
    columnName: 'select',
    columnDisplayValue: 'Select',
    classThName: HEAD_SELECT,
    classTdName: '',
    hasSort: false
  },
  {
    columnName: 'accessionId',
    columnDisplayValue: ACCESSION_ID,
    classThName: HEAD_EXSHORT_PADDING_RIGHT,
    classTdName: OVERFLOW_CONTROL_CONTENTWRAP_RESULT_GRID,
    type: ClindxTableFilterType.inputType,
    maxLength: 20
  },
  {
    columnName: 'clientIdentifier1',
    columnDisplayValue: 'ID#1',
    classThName: HEAD_EXSHORT,
    classTdName: OVERFLOW_CONTROL_CONTENT_WRAP,
    maxLength: 20
  },
  {
    columnName: 'clientIdentifier2',
    columnDisplayValue: 'ID#2',
    classThName: HEAD_EXSHORT,
    classTdName: OVERFLOW_CONTROL_CONTENT_WRAP,
    type: ClindxTableFilterType.inputType,
    maxLength: 20
  },
  {
    columnName: 'clientIdentifier3',
    columnDisplayValue: 'ID#3',
    classThName: HEAD_EXSHORT,
    classTdName: OVERFLOW_CONTROL_CONTENT_WRAP,
    type: ClindxTableFilterType.inputType,
    maxLength: 20
  },
  {
    columnName: 'clientIdentifier4',
    columnDisplayValue: 'ID#4',
    classThName: HEAD_EXSHORT,
    classTdName: OVERFLOW_CONTROL_CONTENT_WRAP,
    type: ClindxTableFilterType.inputType,
    maxLength: 20
  },
  {
    columnName: 'donorName',
    columnDisplayValue: 'Donor',
    classThName: 'head-long',
    classTdName: OVERFLOW_CONTROL_CONTENT_WRAP,
    columnWidth: '7%',
    type: ClindxTableFilterType.inputType,
    maxLength: 102
  },
  {
    columnName: 'receivedOn',
    columnDisplayValue: 'Received On',
    classThName: HEAD_EXSHORT,
    classTdName: OVERFLOW_CONTROL_CONTENTWRAP_RESULT_GRID,
    type: ClindxTableFilterType.dateRangeType
  },
  {
    columnName: 'collectedOn',
    columnDisplayValue: 'Collected On',
    classThName: HEAD_EXSHORT,
    classTdName: OVERFLOW_CONTROL_CONTENTWRAP_RESULT_GRID
  },
  {
    columnName: 'reportedOn',
    columnDisplayValue: 'Reported On',
    classThName: HEAD_EXSHORT,
    classTdName: OVERFLOW_CONTROL_CONTENTWRAP_RESULT_GRID,
    type: ClindxTableFilterType.dateRangeType
  },
  {
    columnName: 'linkAccount',
    columnDisplayValue: 'Main Account',
    classThName: 'head-long',
    classTdName: OVERFLOW_CONTROL_CONTENT_WRAP,
    columnWidth: '8%',
    dataAccessor: (row) => {
      return `${row.mainAccountName} ${row.mainAccountCode}`;
    }
  },
  {
    columnName: 'status',
    columnDisplayValue: 'Status',
    classThName: HEAD_SHORT,
    classTdName: OVERFLOW_CONTROL_CONTENTWRAP_RESULT_GRID,
    columnWidth: '7%',
    type: ClindxTableFilterType.enumType,
    isMulti: true
  },
  {
    columnName: 'report',
    columnDisplayValue: 'Report',
    classThName: HEAD_EXSHORT_PADDING_RIGHT_REPORT,
    classTdName: '',
    columnWidth: '2%',
    hasSort: false
  },
];

export const OrderResultColumnListTgi = [
  {
    columnName: 'select',
    columnDisplayValue: 'Select',
    classThName: 'head-select',
    classTdName: '',
    hasSort: false
  },
  {
    columnName: 'accessionId',
    columnDisplayValue: ACCESSION_ID,
    classThName: HEAD_EXSHORT_PADDING_RIGHT,
    classTdName: OVERFLOW_CONTROL_CONTENTWRAP_RESULT_GRID,
    type: ClindxTableFilterType.inputType,
    maxLength: 20
  },
  {
    columnName: 'patientName',
    columnDisplayValue: 'Patient',
    classThName: HEAD_EXSHORT,
    classTdName: OVERFLOW_CONTROL,
    dataAccessor: (row) => {
      return [row.patientLastName, row.patientFirstName, row.patientMI]
        .filter((val: string) => val?.toString().length).join(', ');
    }
  },
  {
    columnName: 'patientDOB',
    columnDisplayValue: 'DOB',
    classThName: HEAD_EXSHORT,
    classTdName: PADDING_RIGHT,
    type: ClindxTableFilterType.dateWithValidationType,
    placeHolder: DOB_FORMAT
  },
  {
    columnName: 'receivedOn',
    columnDisplayValue: 'Received On',
    classThName: HEAD_EXSHORT,
    classTdName: OVERFLOW_CONTROL_CONTENTWRAP_RESULT_GRID,
    type: ClindxTableFilterType.dateRangeType
  },
  {
    columnName: 'collectedOn',
    columnDisplayValue: 'Collected On',
    classThName: HEAD_EXSHORT,
    classTdName: OVERFLOW_CONTROL_CONTENTWRAP_RESULT_GRID
  },
  {
    columnName: 'reportedOn',
    columnDisplayValue: 'Reported On',
    classThName: HEAD_EXSHORT,
    classTdName: OVERFLOW_CONTROL_CONTENTWRAP_RESULT_GRID,
    type: ClindxTableFilterType.dateRangeType
  },
  {
    columnName: 'tests',
    columnDisplayValue: 'Test(s)/Panel(s)',
    classThName: 'head-long',
    classTdName: OVERFLOW_CONTROL,
    hasSort: false,
    type: ClindxTableFilterType.inputType,
    maxLength: 75,
  },
  {
    columnName: 'linkAccount',
    columnDisplayValue: 'Main Account',
    classThName: 'head-long',
    classTdName: OVERFLOW_CONTROL_CONTENT_WRAP,
    columnWidth: '8%',
    dataAccessor: (row) => {
      return `${row.mainAccountName} ${row.mainAccountCode}`;
    }
  },
  {
    columnName: 'physicianName',
    columnDisplayValue: 'Physician',
    classThName: HEAD_EXSHORT,
    classTdName: OVERFLOW_CONTROL,
    type: ClindxTableFilterType.inputType,
    maxLength: 102,
    dataAccessor: (row) => {
      if ((row.physicianFirstName?.toLowerCase() === Constants.LOWERCASE_UNDEFINED) &&
          (row.physicianLastName?.toLowerCase() === Constants.LOWERCASE_UNDEFINED) &&
          (row.npiNumber === null || row.npiNumber === 0)) {
        return Constants.UNDEFINED;
      }

      return [row.physicianFirstName, row.physicianLastName]
        .filter((val: string) => val?.toString().length).join(' ');
    }
  },
  {
    columnName: 'status',
    columnDisplayValue: 'Status',
    classThName: HEAD_SHORT,
    classTdName: OVERFLOW_CONTROL_CONTENTWRAP_RESULT_GRID,
    columnWidth: '7%',
    type: ClindxTableFilterType.enumType,
    isMulti: true
  },
  {
    columnName: 'resultDetails',
    columnDisplayValue: 'Result',
    classThName: HEAD_SHORT,
    classTdName: OVERFLOW_CONTROL,
    hasSort: false,
    type: ClindxTableFilterType.inputType,
    maxLength: 50
  },
  {
    columnName: 'report',
    columnDisplayValue: 'Report',
    classThName: HEAD_EXSHORT_PADDING_RIGHT_REPORT,
    classTdName: '',
    columnWidth: '2%',
    hasSort: false
  },
];

export const OrderDashboardResultColumnList = [
  {
    columnName: 'accessionId',
    columnDisplayValue: ACCESSION_ID,
    classThName: HEAD_EXSHORT_PADDING_RIGHT,
    classTdName: PADDING_RIGHT,
    hasSort: false,
    maxLength: 20
  },
  {
    columnName: 'reportName',
    columnDisplayValue: 'ReportName',
    classThName: HEAD_SHORT,
    classTdName: 'overflow-control-dashboardResultGrid',
    columnWidth: '4%',
    hasSort: false,
    maxLength: 50
  },
  {
    columnName: 'reportedOn',
    columnDisplayValue: 'Generated On',
    classThName: HEAD_EXSHORT,
    classTdName: 'padding-right',
    hasSort: false,
  },
  {
    columnName: 'report',
    columnDisplayValue: 'Download',
    classThName: HEAD_EXSHORT_PADDING_RIGHT_REPORT,
    classTdName: '',
    columnWidth: '2%',
    hasSort: false
  }
];

export const ManageUserColumnList = [
  {
    columnName: 'email',
    columnDisplayValue: 'Email',
    classThName: 'head-exlong',
    classTdName: EMAIL_COLUMN_CLASS,
    type: ClindxTableFilterType.inputType,
    maxLength: 100
  },
  {
    columnName: 'firstName',
    columnDisplayValue: FIRST_NAME,
    classThName: 'head-long',
    classTdName: OVERFLOW_CONTROL_CONTENT_WRAP,
    type: ClindxTableFilterType.inputType,
    maxLength: 50
  },
  {
    columnName: 'lastName',
    columnDisplayValue: 'Last Name',
    classThName: 'head-long',
    classTdName: OVERFLOW_CONTROL_CONTENT_WRAP,
    type: ClindxTableFilterType.inputType,
    maxLength: 50
  },
  {
    columnName: 'creationDate',
    columnDisplayValue: 'Creation Date',
    classThName: HEAD_CREATION_DATE,
    classTdName: DATA_CREATION_DATE,
    type: ClindxTableFilterType.dateType
  },
  {
    columnName: 'linkedAccounts',
    columnDisplayValue: 'Linked Account(s)',
    classThName: 'head-long',
    classTdName: '',
    hasSort: false,
    type: ClindxTableFilterType.inputType,
    maxLength: 100
  },
  {
    columnName: 'status',
    columnDisplayValue: 'Status',
    classThName: HEAD_SHORT,
    classTdName: '',
    hasSort: false,
    type: ClindxTableFilterType.enumType,
    args: [
      { name: 'Active', value: 'Active' },
      { name: 'Inactive', value: 'Inactive' }
    ]
  },
  {
    columnName: 'actions',
    columnDisplayValue: 'Edit User',
    classThName: HEAD_SHORT,
    classTdName: '',
    hasSort: false
  }
];

export const MarkersColumnList = [
  {
    columnName: 'markerName',
    columnDisplayValue: 'Markers',
    classThName: '',
    classTdName: 'OverflowControl',
    hasSort: false
  },
  {
    columnName: 'value',
    columnDisplayValue: 'Value',
    classThName: '',
    classTdName: '',
    hasSort: false
  },
  {
    columnName: 'moM',
    columnDisplayValue: 'MoM',
    classThName: '',
    classTdName: '',
    hasSort: false
  },
  {
    columnName: 'percentile',
    columnDisplayValue: 'Percentile',
    classThName: '',
    classTdName: '',
    hasSort: false
  },
];

export const OrderReportColumnList = [
  {
    columnName: 'reportName',
    columnDisplayValue: 'Report Name',
    classThName: '',
    classTdName: '',
    hasSort: false
  },
  {
    columnName: 'generatedOn',
    columnDisplayValue: 'Generated On',
    classThName: '',
    classTdName: '',
    hasSort: false
  },
  {
    columnName: 'share',
    columnDisplayValue: 'Share',
    classThName: '',
    classTdName: '',
    hasSort: false
  }
];

export const RisksTableColumnNames = [
  {
    columnName: 'riskName',
    columnDisplayValue: 'Risks',
    classThName: '',
    classTdName: '',
    hasSort: false
  },
  {
    columnName: 'cutOff',
    columnDisplayValue: 'Cut-Off',
    classThName: '',
    classTdName: '',
    hasSort: false
  },
  {
    columnName: 'riskBeforeScreening',
    columnDisplayValue: 'Risk Before Screening',
    classThName: '',
    classTdName: '',
    hasSort: false
  },
  {
    columnName: 'riskAfterScreening',
    columnDisplayValue: 'Risk After Screening',
    classThName: '',
    classTdName: '',
    hasSort: false
  },
  {
    columnName: 'result',
    columnDisplayValue: 'Result',
    classThName: '',
    classTdName: '',
    hasSort: false
  }
];

export const ManageInternalUserColumnList = [
  {
    columnName: 'email',
    columnDisplayValue: 'Email',
    classThName: 'head-exlong',
    classTdName: EMAIL_COLUMN_CLASS,
    type: ClindxTableFilterType.inputType,
    maxLength: 100
  },
  {
    columnName: 'firstName',
    columnDisplayValue: FIRST_NAME,
    classThName: 'head-long',
    classTdName: OVERFLOW_CONTROL_CONTENT_WRAP,
    type: ClindxTableFilterType.inputType,
    maxLength: 50
  },
  {
    columnName: 'lastName',
    columnDisplayValue: 'Last Name',
    classThName: 'head-long',
    classTdName: OVERFLOW_CONTROL_CONTENT_WRAP,
    type: ClindxTableFilterType.inputType,
    maxLength: 50
  },
  {
    columnName: 'puid',
    columnDisplayValue: 'PUID',
    classThName: HEAD_EXSHORT,
    classTdName: OVERFLOW_CONTROL_CONTENT_WRAP,
    hasSort: false,
    type: ClindxTableFilterType.inputType,
    maxLength: 4
  },
  {
    columnName: 'creationDate',
    columnDisplayValue: 'Creation Date',
    classThName: HEAD_CREATION_DATE,
    classTdName: DATA_CREATION_DATE,
    type: ClindxTableFilterType.dateType
  },
  {
    columnName: 'linkedBu',
    columnDisplayValue: 'Linked BU(s)',
    classThName: 'head-long',
    classTdName: '',
    hasSort: false,
    type: ClindxTableFilterType.inputType,
    maxLength: 10
  },
  {
    columnName: 'status',
    columnDisplayValue: 'Status',
    classThName: HEAD_EXSHORT,
    classTdName: '',
    hasSort: false,
    type: ClindxTableFilterType.enumType,
    args: [
      { name: 'Active', value: 'Active' },
      { name: 'Inactive', value: 'Inactive' }
    ]
  },
  {
    columnName: 'actions',
    columnDisplayValue: 'Edit User',
    classThName: HEAD_EXSHORT,
    classTdName: '',
    hasSort: false
  }
];

export const ManageAnnouncementsColumnList = [
  {
    columnName: 'lastModifiedOn',
    columnDisplayValue: ANNOUNCEMENT_LAST_UPDATED_ON,
    classThName: 'head-lastModifiedDate',
    classTdName: 'data-lastModifiedDate',
    type: ClindxTableFilterType.dateType,
  },
  {
    columnName: 'lastModifiedBy',
    columnDisplayValue: ANNOUNCEMENT_LAST_UPDATED_BY,
    classThName: 'head-long',
    classTdName: OVERFLOW_CONTROL_CONTENT_WRAP,
    type: ClindxTableFilterType.inputType,
    maxLength: 50,
  },
  {
    columnName: 'title',
    columnDisplayValue: 'Title',
    classThName: 'head-long',
    classTdName: OVERFLOW_CONTROL_CONTENT_WRAP,
    type: ClindxTableFilterType.inputType,
    maxLength: 50,
  },
  {
    columnName: 'publishFromDate',
    columnDisplayValue: 'Publish from date',
    classThName: HEAD_CREATION_DATE,
    classTdName: DATA_CREATION_DATE,
    type: ClindxTableFilterType.dateType
  },
  {
    columnName: 'publishToDate',
    columnDisplayValue: 'Publish to date',
    classThName: HEAD_CREATION_DATE,
    classTdName: DATA_CREATION_DATE,
    type: ClindxTableFilterType.dateType
  },
  {
    columnName: 'businessUnits',
    columnDisplayValue: 'BU(s)',
    classThName: HEAD_CREATION_DATE,
    classTdName: DATA_CREATION_DATE,
    hasSort: false,
    type: ClindxTableFilterType.inputType,
    maxLength: 50,
  },
  {
    columnName: 'edit1',
    columnDisplayValue: 'Actions',
    classThName: HEAD_EXSHORT,
    classTdName: '',
    hasSort: false
  }
];